/* DIALED truck selector: Make → Model → Year → Bed resolves to a kit variant.
   Fitment data lives in assets/dialed-fitment.json (edit without touching code).
   Resolution: class midsize → Midsize kit; class fullsize + long bed → Full-size
   long bed kit; else Full-size kit. Panels = bed ft × panels across; strips = bed ft × 2. */
(function () {
  'use strict';
  if (customElements.get('dialed-truck-selector')) return;

  var fitmentCache = null;
  function loadFitment(url) {
    if (fitmentCache) return fitmentCache;
    fitmentCache = fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('Fitment table failed to load');
      return r.json();
    });
    return fitmentCache;
  }
  function money(cents) { return window.DLD && DLD.money ? DLD.money(cents) : String(cents / 100); }
  function bedShort(bed) { return String(bed.label || '').split(' · ')[0].toLowerCase(); }

  var Selector = function () { return Reflect.construct(HTMLElement, [], Selector); };
  Selector.prototype = Object.create(HTMLElement.prototype);
  Selector.prototype.constructor = Selector;
  Object.setPrototypeOf(Selector, HTMLElement);

  Selector.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var cfgEl = this.querySelector('script[data-dld-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.cfg.variants = this.cfg.variants || [];
    this.cfg.kitMap = this.cfg.kitMap || {};
    this.cfg.labels = this.cfg.labels || {};
    this.state = { make: '', model: '', year: '', bed: '', organizer: false, qty: 1 };
    this.sel = {
      make: this.querySelector('[data-dld-make]'),
      model: this.querySelector('[data-dld-model]'),
      year: this.querySelector('[data-dld-year]'),
      bed: this.querySelector('[data-dld-bed]')
    };
    this.binds = Array.prototype.slice.call(document.querySelectorAll('[data-dld-bind]'));
    this.tpls = Array.prototype.slice.call(document.querySelectorAll('[data-dld-tpl]'));
    this.tpls.forEach(function (el) { if (!el.hasAttribute('data-dld-tpl-src')) el.setAttribute('data-dld-tpl-src', el.getAttribute('data-dld-tpl') || el.textContent); });
    this.bindEvents();
    var self = this;
    loadFitment(this.cfg.fitmentUrl).then(function (data) {
      self.fitment = data;
      self.populateMakes();
      self.populateYears();
      self.applyHash();
      self.update();
    }).catch(function (err) {
      self.fail(err);
    });
    this.update();
  };

  Selector.prototype.fail = function (err) {
    var pill = this.querySelector('[data-dld-pill-title]');
    if (pill) pill.textContent = this.cfg.labels.loadError || 'Fitment table unavailable';
    if (window.console) console.warn('[DIALED]', err);
  };

  Selector.prototype.bindEvents = function () {
    var self = this, s = this.sel;
    if (s.make) s.make.addEventListener('change', function () { self.state.make = s.make.value; self.state.model = ''; self.state.bed = ''; self.populateModels(); self.update(); });
    if (s.model) s.model.addEventListener('change', function () { self.state.model = s.model.value; self.state.bed = ''; self.update(); });
    if (s.year) s.year.addEventListener('change', function () { self.state.year = s.year.value; self.update(); });
    if (s.bed) s.bed.addEventListener('change', function () { self.state.bed = s.bed.value; self.update(); });

    var org = this.querySelector('[data-dld-organizer]');
    if (org) org.addEventListener('click', function () { self.state.organizer = !self.state.organizer; self.update(); });
    var inc = this.querySelector('[data-dld-qty-inc]'), dec = this.querySelector('[data-dld-qty-dec]');
    if (inc) inc.addEventListener('click', function () { self.state.qty = Math.min(9, self.state.qty + 1); self.update(); });
    if (dec) dec.addEventListener('click', function () { self.state.qty = Math.max(1, self.state.qty - 1); self.update(); });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dld-add]');
      if (!b) return;
      var scope = b.getAttribute('data-dld-add');
      if (scope && scope !== self.cfg.scope) return;
      e.preventDefault();
      self.add();
    });
    window.addEventListener('hashchange', function () { self.applyHash(); self.update(); });
  };

  Selector.prototype.applyHash = function () {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    if (h === 'bundle' && this.querySelector('[data-dld-organizer]')) this.state.organizer = true;
    if (h === 'midsize' || h === 'fullsize' || h === 'bundle' || h === 'buy') {
      var el = this.querySelector('[data-dld-anchor]') || this;
      try { el.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { el.scrollIntoView(); }
      if ((h === 'midsize' || h === 'fullsize') && this.sel.make && !this.state.make) this.sel.make.focus({ preventScroll: true });
    }
  };

  Selector.prototype.option = function (value, label, selected) {
    var o = document.createElement('option');
    o.value = value; o.textContent = label; if (selected) o.selected = true; return o;
  };

  Selector.prototype.populateMakes = function () {
    var s = this.sel.make; if (!s || !this.fitment) return;
    var self = this;
    var keep = s.value;
    s.innerHTML = '';
    s.appendChild(this.option('', this.cfg.labels.selectMake || 'Select make'));
    (this.fitment.makes || []).forEach(function (m) { s.appendChild(self.option(m.name, m.name, m.name === keep)); });
    this.state.make = s.value;
    this.populateModels();
  };

  Selector.prototype.populateModels = function () {
    var s = this.sel.model; if (!s || !this.fitment) return;
    var self = this;
    var make = this.findMake();
    s.innerHTML = '';
    s.appendChild(this.option('', make ? (this.cfg.labels.selectModel || 'Select model') : (this.cfg.labels.pickMakeFirst || 'Pick make first')));
    if (make) (make.models || []).forEach(function (m) { s.appendChild(self.option(m.name, m.name, m.name === self.state.model)); });
    this.state.model = s.value;
  };

  Selector.prototype.populateYears = function () {
    var s = this.sel.year; if (!s || !this.fitment) return;
    var y = this.fitment.years || { from: 2010, to: 2025 };
    s.innerHTML = '';
    for (var i = y.to; i >= y.from; i--) s.appendChild(this.option(String(i), String(i), i === y.to));
    this.state.year = s.value;
  };

  Selector.prototype.populateBeds = function (cls) {
    var s = this.sel.bed; if (!s || !cls) return;
    var self = this;
    var beds = cls.beds || [];
    var current = this.state.bed;
    if (s.getAttribute('data-class') === cls.id && s.options.length) {
      return;
    }
    s.innerHTML = '';
    beds.forEach(function (b, i) { s.appendChild(self.option(b.id, b.label, current ? b.id === current : i === 0)); });
    s.setAttribute('data-class', cls.id);
    this.state.bed = s.value;
  };

  Selector.prototype.findMake = function () {
    var self = this;
    return (this.fitment && this.fitment.makes || []).filter(function (m) { return m.name === self.state.make; })[0] || null;
  };

  Selector.prototype.resolve = function () {
    var f = this.fitment;
    var make = this.findMake();
    var model = make ? (make.models || []).filter(function (m) { return m.name === this.state.model; }, this)[0] : null;
    var classes = (f && f.classes) || {};
    var clsId = model ? model['class'] : (make && make.models && make.models[0] ? make.models[0]['class'] : 'fullsize');
    var cls = classes[clsId] ? Object.assign({ id: clsId }, classes[clsId]) : { id: 'fullsize', label: 'Full-size', across: 4, kit: 'fullsize', beds: [] };
    this.populateBeds(cls);
    var beds = cls.beds || [];
    var bed = beds.filter(function (b) { return b.id === this.state.bed; }, this)[0] || beds[0] || { id: 'short', label: 'Short', ft: 5 };
    var kitKey = bed.kit || cls.kit || cls.id;
    var kitTitle = this.cfg.kitMap[kitKey] || '';
    var variant = this.cfg.variants.filter(function (v) { return v.title === kitTitle; })[0] || null;
    var ready = !!(this.state.make && this.state.model && variant);
    var across = cls.across || 4;
    var panels = (bed.ft || 0) * across;
    var strips = (bed.ft || 0) * 2;
    var org = this.cfg.organizer && this.state.organizer ? this.cfg.organizer : null;
    var unit = (variant ? variant.price : 0) + (org ? org.price : 0);
    var total = unit * this.state.qty;
    var truck = ready ? (this.state.year + ' ' + this.state.make + ' ' + this.state.model + ' · ' + bedShort(bed) + ' bed') : '';
    var kitName = variant ? variant.title : (this.cfg.labels.kitFallback || 'Truck kit');
    return { ready: ready, cls: cls, bed: bed, variant: variant, kitKey: kitKey, across: across, panels: panels, strips: strips, organizer: org, unit: unit, total: total, truck: truck, kitName: kitName };
  };

  Selector.prototype.update = function () {
    var r = this.resolve();
    var L = this.cfg.labels;
    var s = this.sel;
    var noMake = !this.state.make;
    [s.model, s.year, s.bed].forEach(function (el) { if (el) el.disabled = noMake; });
    this.classList.toggle('is-ready', r.ready);

    var minPrice = this.cfg.variants.reduce(function (m, v) { return m === null || v.price < m ? v.price : m; }, null);
    var set = function (sel, text) { var el = this.querySelector(sel); if (el) el.textContent = text; }.bind(this);

    set('[data-dld-pill-title]', noMake ? (L.pillIdle || 'Select your truck') : (this.state.model ? r.kitName : (L.pillModel || 'Select model')));
    set('[data-dld-pill-sub]', noMake ? (L.pillIdleSub || 'Kit and price size to your bed') : (this.state.model ? (r.bed.ft + ' × ' + r.across + ' ' + (L.panels || 'panels') + ' · ' + (r.bed.ft * 12) + ' × ' + (r.across * 12) + ' in') : ''));

    var priceText = r.ready ? money(r.total) : ((L.from || 'From') + ' ' + money(minPrice || 0));
    set('[data-dld-price]', priceText);
    var listed = this.cfg.variants.map(function (v) { return v.title.replace(/\s+kit$/i, '').replace(/full-size long bed/i, 'Long bed') + ' ' + money(v.price); }).join(' · ');
    var priceLabel;
    if (this.cfg.scope === 'product') {
      priceLabel = r.organizer ? (r.kitName + ' + ' + (L.organizerShort || 'organizer pack')) : r.kitName;
    } else {
      priceLabel = r.ready ? (r.kitName + (L.priceSuffix ? ' · ' + L.priceSuffix : '')) : listed;
    }
    set('[data-dld-price-label]', priceLabel);
    set('[data-dld-price-note]', this.state.qty > 1 ? (this.state.qty + ' ' + (L.kitsNote || 'kits') + (L.priceNote ? ' · ' + L.priceNote.toLowerCase() : '')) : (L.priceNote || ''));

    set('[data-dld-inc-panels]', r.ready ? (r.panels + ' ' + (L.mainPanels || 'main panels')) : (L.panelsIdle || 'Main panels sized to your bed'));
    set('[data-dld-inc-strips]', r.ready ? (r.strips + ' ' + (L.fitStrips || 'fit strips')) : (L.stripsIdle || 'Fit strips for the walls'));

    var addLabel = r.ready ? ((L.addToCart || 'Add to cart') + ' · ' + money(r.total)) : (L.selectToAdd || 'Select your truck to add');
    Array.prototype.slice.call(this.querySelectorAll('[data-dld-add-label]')).forEach(function (el) { el.textContent = addLabel; });
    Array.prototype.slice.call(document.querySelectorAll('[data-dld-add-label-global="' + this.cfg.scope + '"]')).forEach(function (el) { el.textContent = addLabel; });

    this.step();
    var org = this.querySelector('[data-dld-organizer]');
    if (org) org.setAttribute('aria-checked', this.state.organizer ? 'true' : 'false');
    var qty = this.querySelector('[data-dld-qty-value]');
    if (qty) qty.textContent = String(this.state.qty);

    var ctx = {
      panels: r.panels, strips: r.strips, kit: r.kitName, truck: r.truck || (L.yourTruck || 'your truck'),
      bed: bedShort(r.bed), 'class': (r.cls.label || '').toLowerCase(), total: r.ready ? money(r.total) : priceText,
      qty: this.state.qty, accessories: r.organizer ? (6 + (this.cfg.organizer.pieces || 0)) : 6
    };
    this.tpls.forEach(function (el) {
      var src = el.getAttribute('data-dld-tpl-src') || '';
      el.textContent = src.replace(/\{(\w+)\}/g, function (m, k) { return k in ctx ? ctx[k] : m; });
    });
    this.binds.forEach(function (el) {
      var k = el.getAttribute('data-dld-bind');
      if (k in ctx) el.textContent = String(ctx[k]);
    });
    var on = !!r.organizer;
    Array.prototype.slice.call(document.querySelectorAll('[data-dld-show="organizer"]')).forEach(function (el) { el.hidden = !on; });
    Array.prototype.slice.call(document.querySelectorAll('[data-dld-hide="organizer"]')).forEach(function (el) { el.hidden = on; });

    this.current = r;
    document.dispatchEvent(new CustomEvent('dialed:selection', { detail: r }));
  };

  /* Phones: reveal Model after Make, then Year and Bed after Model. */
  Selector.prototype.step = function () {
    var s = this.sel;
    var stepped = window.matchMedia('(max-width: 759px)').matches;
    var self = this;
    var fieldOf = function (sel) { return sel && sel.closest('.dld-field'); };
    var rules = [[fieldOf(s.model), !!this.state.make], [fieldOf(s.year), !!this.state.model], [fieldOf(s.bed), !!this.state.model]];
    rules.forEach(function (r) {
      var field = r[0];
      if (!field) return;
      var show = !stepped || r[1];
      var wasHidden = field.classList.contains('is-step-hidden');
      field.classList.toggle('is-step-hidden', !show);
      field.classList.toggle('is-step-in', show && wasHidden);
    });
    if (!this._stepBound) {
      this._stepBound = true;
      var mq = window.matchMedia('(max-width: 759px)');
      var onChange = function () { self.step(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
    }
  };

  Selector.prototype.add = function () {
    var r = this.current || this.resolve();
    if (!r.ready) {
      var card = this.querySelector('[data-dld-selector-card]');
      if (card) { card.classList.remove('is-attention'); void card.offsetWidth; card.classList.add('is-attention'); }
      try { (this.sel.make || this).scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      if (this.sel.make) this.sel.make.focus({ preventScroll: true });
      return;
    }
    var items = [{ id: r.variant.id, quantity: this.state.qty, properties: { Truck: r.truck } }];
    if (r.organizer) items.push({ id: r.organizer.id, quantity: this.state.qty, properties: { Truck: r.truck } });
    if (window.DLD && DLD.cart) DLD.cart.add(items);
  };

  customElements.define('dialed-truck-selector', Selector);
})();
